/** O aplicativo Desktop Ulemo (Electron) usa o user agent por omissão do
 * Electron, que inclui sempre "Electron/x.y.z". Um navegador comum nunca tem
 * isto — é a forma padrão de distinguir os dois. */
export function estaNoAppDesktop(): boolean {
  return /Electron/i.test(navigator.userAgent);
}
